import { DeesElement, property, html, customElement, TemplateResult } from '@designestate/dees-element';

import * as themelogic from '../themelogic';

declare global {
  interface HTMLElementTagNameMap {
    'lele-theme': LeleTheme;
  }
}

@customElement('lele-theme')
export class LeleTheme extends DeesElement {

  constructor() {
    super();

    // you have access to all kinds of things through this.
    // this.setAttribute('gotIt','true');
    
  }

  public render(): TemplateResult {
    return html`
      <style>
        :host {
          /** css vars */
          --lelecv-background-accent: ${themelogic.leleCv.backgroundAccent};
          --lelecv-background1: ${this.goBright ? '#ffffff' : '#000000'};
          --lelecv-background2: ${this.goBright ? '#e2e2e2' : '#1C1C1C'};
          --lelecv-background3: ${this.goBright ? '#fafafa' : '#111111'};
          --lelecv-color-font: ${this.goBright ? '#000' : '#fff'};
          --lelecv-color-accent: #e4002b;
          --lelecv-pagewidth: ${themelogic.leleCv.pageWidth};

          /** base css */
          font-family: 'Roboto', sans-serif;
          background: var(--lelecv-background1);
          box-shadow: 0px 0px 5px rgba(0,0,0,0.6);
          display: block;
          box-sizing: border-box;

          
        }
        :host([hidden]) {
          display: none;
        }
      </style>
      <slot></slot>
    `;
  }
}
